// extracted by mini-css-extract-plugin
export var anchor = "quote-module--anchor--1Undk";
export var outerContainer = "quote-module--outer-container--xymme";
export var topAnimation = "quote-module--top-animation--1lN3Z";
export var bottomAnimation = "quote-module--bottom-animation--3eeEG";
export var animatedText = "quote-module--animated-text--fihbH";
export var topText = "quote-module--top-text--3VBfB";
export var bottomText = "quote-module--bottom-text--34Bu_";
export var textFadeTransition = "quote-module--text-fade-transition--2oK_3";